import Vue from "vue";
import Vuex from "vuex";
import request from '@/request'
import Dashboard from './modules/Dashboard'
import Service from './modules/Service'
import FeedbackAndEnroll from './modules/FeedbackAndEnroll'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    pdfData: '',
    fileName:'',
    logined: false
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    async login ({ commit },payload) {
      const response = { status: 'init', massage: null }
      await request({
        method: 'post',
        url: process.env.VUE_APP_API_LOGIN,
        data: payload
      })
        .then(res => {
          response.status = res.status
          response.massage = res.statusText
          response.data = res
        })
        .catch(error => {
        // console.error('res error >>>', error, error.response)
          response.code = error.response
          response.massage = error.response
        })
      return response
    }
  },
  modules: {
    Dashboard,
    Service,
    FeedbackAndEnroll
  },
});
